import React from "react";
import "./Companies.css";

const companies = [
  "SYNERGY HomeCare",
  "EZ Phone Fix",
  "Goodworth Furniture",
  "Metro Mobile Locksmith",
  "Shah Sawood",
  "AtoZ Used Furniture",
  "Najam Al Wali Furniture",
  "Salem Drywall & Repair",
  "Social Security Disability Law Firm",
];

const TrustedCompanies = () => {
  // Duplicate the list so the animation can loop smoothly
  const marqueeCompanies = [...companies, ...companies];

  return (
    <section className="trusted-section">

      <div className="trusted-container">

        <p className="trusted-title">
          TRUSTED BY MOST INNOVATIVE COMPANY
        </p>

        <div className="logo-marquee">

          <div className="logo-track">

            {marqueeCompanies.map((company, index) => (
              <div
                className="company-card"
                key={`${company}-${index}`}
              >
                <span>{company}</span>
              </div>
            ))}

          </div>

        </div>

      </div>

    </section>
  );
};

export default TrustedCompanies;